import {
  GET_CHAUFFEURS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  UPDATE_CHAUFFEUR,
  UPDATE_CHAUFFEUR_SUCCESS,
  UPDATE_CHAUFFEUR_FAIL,
  ADD_NEW_CHAUFFEUR,
  ADD_CHAUFFEUR_SUCCESS,
  ADD_CHAUFFEUR_FAIL,
} from "./actionType";

// common success
export const chauffeurApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const chauffeurApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getChauffeurs = () => ({
  type: GET_CHAUFFEURS,
});

export const updateChauffeur = (chauffeur) => ({
  type: UPDATE_CHAUFFEUR,
  payload: chauffeur,
});

export const updateChauffeurSuccess = (chauffeur) => ({
  type: UPDATE_CHAUFFEUR_SUCCESS,
  payload: chauffeur,
});

export const updateChauffeurFail = (error) => ({
  type: UPDATE_CHAUFFEUR_FAIL,
  payload: error,
});

export const addNewChauffeur = (chauffeur) => ({
  type: ADD_NEW_CHAUFFEUR,
  payload: chauffeur,
});

export const addChauffeurSuccess = (chauffeur) => ({
  type: ADD_CHAUFFEUR_SUCCESS,
  payload: chauffeur,
});

export const addChauffeurFail = (error) => ({
  type: ADD_CHAUFFEUR_FAIL,
  payload: error,
});
